var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHistoryPartialIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_160836",
    "data-name": "Group 160836",
    transform: "translate(-1276.425 -284.425)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160840",
    "data-name": "Group 160840",
    transform: "translate(1276.425 284.425)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160839",
    "data-name": "Group 160839",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_266",
    "data-name": "Ellipse 266",
    cx: 6.5,
    cy: 6.5,
    r: 6.5,
    fill: "rgba(240,157,24,0.9)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_202",
    "data-name": "Line 202",
    y2: 2.87,
    transform: "translate(6.5 3.5)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_203",
    "data-name": "Line 203",
    transform: "translate(6.5 9.154)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistoryPartialIcon);
export default __webpack_public_path__ + "static/media/history-partial-icon.0a48b5244129f3b35b90ae2577f97f92.svg";
export { ForwardRef as ReactComponent };